import { Navigate, Route, Routes } from 'react-router-dom';
import { AnimatedOutlet } from '@shared/components/AnimatedOutlet';
import { SuperAdminAuthenticatedPath } from '@shared/constants/routes.constants';
import { CompaniesPage } from '@pages/SuperAdmin/CompaniesPage';
import { FullLayout } from '@shared/layouts';
import { MonitorConversationPage } from '@pages/SuperAdmin/MonitorConversationPage';
import { HomePage } from '@pages/SuperAdmin/HomePage';
import { EditCompanyPage } from '@pages/SuperAdmin/EditCompany';
import ManageVoiceSettings from '@pages/SuperAdmin/ManageVoiceSettingsPage/ui';
import { ManageTranscriberPage } from '@pages/SuperAdmin/ManageTranscriberPage/ui';
import { MonitoringTokensPage } from '@pages/SuperAdmin/MonitoringTokensPage';
import { UnitWeightsPage } from '@pages/SuperAdmin/UnitWeightsPage';
import { ManageAmbienceSoundsPage } from '@pages/SuperAdmin/ManageAmbienceSoundsPage';

export const AuthorizedSuperAdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<FullLayout />}>
        <Route element={<AnimatedOutlet />}>
          <Route index element={<Navigate to="/super-admin/home" replace />} />
          <Route path="/super-admin/home" element={<HomePage />} />
          <Route path={SuperAdminAuthenticatedPath.COMPANIES} element={<CompaniesPage />} />
          <Route
            path={SuperAdminAuthenticatedPath.MONITOR_TOKENS}
            element={<MonitoringTokensPage />}
          />
          <Route
            path={SuperAdminAuthenticatedPath.MONITOR_CONVERSATION}
            element={<MonitorConversationPage />}
          />
          <Route
            path={SuperAdminAuthenticatedPath.MANAGE_VOICE_SETTINGS}
            element={<ManageVoiceSettings />}
          />
          <Route
            path={SuperAdminAuthenticatedPath.AMBIENCE_SOUNDS}
            element={<ManageAmbienceSoundsPage />}
          />
          <Route
            path={SuperAdminAuthenticatedPath.MANAGE_TRANSCRIBER}
            element={<ManageTranscriberPage />}
          />
          <Route path={SuperAdminAuthenticatedPath.EDIT_COMPANY} element={<EditCompanyPage />} />
          <Route path={SuperAdminAuthenticatedPath.UNIT_WEIGHTS} element={<UnitWeightsPage />} />
          <Route path="*" element={<Navigate to="/super-admin/home" replace />} />
        </Route>
      </Route>
    </Routes>
  );
};
